import React, { Component } from "react";
import RegDashboard from "./frontpage_dashboard";
// import Bar from "./BarChart";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Button from "react-validation/build/button";
import { Button as RButton } from "react-bootstrap";
import CheckButton from "react-validation/build/button";
import AuthService from "../services/auth.service";
import "./login.css";
import logo from "../assets/img/Artboard2.615bb9be.png";
const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        ต้องกรอกข้อมูล!
      </div>
    );
  }
};

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.onClickHidden = this.onClickHidden.bind(this);

    this.state = {
      username: "",
      password: "",
      loading: false,
      message: "",
      hidden: false,
    };
  }

  onClickHidden() {
    this.setState({
      hidden: !this.state.hidden,
    });
  }

  onChangeUsername(e) {
    this.setState({
      username: e.target.value,
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value,
    });
  }

  handleLogin(e) {
    e.preventDefault();

    this.setState({
      message: "",
      loading: true,
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
      AuthService.login(this.state.username, this.state.password).then(
        () => {
          // this.props.history.push("/profile");
          // window.location.reload();
          window.location.replace("/");
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            loading: false,
            message: resMessage,
          });
        }
      );
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  render() {
    return (
      <div className="gradient-custom h-100">
        <RButton onClick={this.onClickHidden} style={{ borderRadius: "3rem" }}>
          {this.state.hidden ? (
            <i className="bi bi-speedometer"> Dashboard</i>
          ) : (
            <i className="bi bi-key"> Login</i>
          )}
        </RButton>
        <a
          href="https://citly.me/utsvP"
          Class="btn btn-custom"
          role="button"
          target="_blank"
          style={{
            borderRadius: "3rem",
            color: "white",
          }}
          rel="noreferrer"
        >
          ประเมินระบบ
        </a>
        <a
          href="https://regsugarcane.ocsb.go.th/eform"
          Class="btn btn-custom"
          role="button"
          target="_blank"
          style={{
            borderRadius: "3rem",
            color: "white",
          }}
          rel="noreferrer"
        >
          E - Form
        </a>
        <a
          href="https://apisugarcane.ocsb.go.th/downloads/manual_staff.pdf"
          Class="btn btn-custom"
          role="button"
          target="_blank"
          style={{
            borderRadius: "3rem",
            color: "white",
          }}
          rel="noreferrer"
        >
          คู่มือเจ้าหน้าที่การจดทะเบียน
        </a>
        <a
          href="https://apisugarcane.ocsb.go.th/downloads/manual_registrar.pdf"
          Class="btn btn-custom"
          role="button"
          target="_blank"
          style={{
            borderRadius: "3rem",
            color: "white",
          }}
          rel="noreferrer"
        >
          คู่มือนายทะเบียน
        </a>

        <div
          className="container py-5 h-100"
          style={{ padding: "0!important" }}
        >
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div
              className={
                this.state.hidden
                  ? "col-12 col-md-8 col-lg-6 col-xl-5"
                  : "col-12 col-md-8 col-lg-6"
              }
            >
              <div
                className="card bg-white text-dark"
                style={
                  this.state.hidden ? { display: "none" } : { padding: "10px" }
                }
              >
                <div className="row">
                  <div className="col-12">
                    <RegDashboard />
                  </div>
                  {/* <div className="col-6">
                    <RegDashboard />
                  </div> */}
                </div>
              </div>
              <div
                className="card bg-white text-dark"
                style={!this.state.hidden ? { display: "none" } : {}}
              >
                <div className="card-body text-center">
                  <div className="" style={{ padding: "2rem" }}>
                    <div>
                      <img
                        src={logo}
                        width="100%"
                        alt="ghlogo"
                        style={{ padding: "20px" }}
                      ></img>
                    </div>

                    <Form
                      onSubmit={this.handleLogin}
                      ref={(c) => {
                        this.form = c;
                      }}
                    >
                      <div className="form-outline form-white mb-4">
                        <label
                          className="form-label text-dark"
                          htmlFor="username"
                        >
                          ชื่อผู้ใช้งาน
                        </label>
                        <Input
                          type="text"
                          className="form-control form-control-lg"
                          name="username"
                          value={this.state.username}
                          onChange={this.onChangeUsername}
                          validations={[required]}
                        />
                      </div>

                      <div className="form-outline form-white mb-4">
                        <label
                          className="form-label text-dark"
                          htmlFor="password"
                        >
                          รหัสผ่าน
                        </label>
                        <Input
                          type="password"
                          className="form-control form-control-lg"
                          name="password"
                          value={this.state.password}
                          onChange={this.onChangePassword}
                          validations={[required]}
                        />
                      </div>

                      <p className="small mb-5 pb-lg-2">
                        <a className="text-dark-50" href="#!">
                          ลืมรหัสผ่าน
                        </a>
                      </p>
                      <Button
                        className="btn btn-dark btn-lg px-5"
                        disabled={this.state.loading}
                      >
                        {this.state.loading && (
                          <span className="spinner-border spinner-border-sm"></span>
                        )}
                        <span>เข้าสู่ระบบ</span>
                      </Button>

                      {this.state.message && (
                        <div className="form-outline form-white mb-4 alignCenter">
                          <div className="alert alert-danger" role="alert">
                            {this.state.message}
                          </div>
                        </div>
                      )}
                      <CheckButton
                        style={{ display: "none" }}
                        ref={(c) => {
                          this.checkBtn = c;
                        }}
                      />
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
